import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import { Typography } from '@totalsoft/rocket-ui';
import { TableBody, TableRow, TableCell, TableHead, Box, IconButton, Grid } from '@mui/material';
import { StyledHeaderCell, StyledGrid, StyledTable, StyledGrayIcon, StyledTableRow } from 'components/common/Styles';
import VerificationTypeUserGroupItemComponent from './VerificationTypeUserGroupItemComponent';
import { Add } from '@mui/icons-material';

const VerificationTypeUserGroupsListComponent = ({
  verificationType,
  userGroups,
  allUserGroups,
  onPropertyChanged,
  onDelete,
  onAdd,
  onCancel,
  onEdit
}) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledGrid container>
        <Grid item>
          <Typography variant='h6'>{t('VerificationTypes.Security')}</Typography>
        </Grid>
        <Grid item>
          <IconButton type='add' fontSize='medium' color='transparent' title={t('Tooltips.Add')} onClick={onAdd}>
            <Add />
          </IconButton>
        </Grid>
      </StyledGrid>
      <Prompt when={verificationType.isDirty} message={t('VerificationTypes.LeavingWithoutSaving')} />
      <StyledTable>
        <TableHead>
          <TableRow>
            <StyledHeaderCell sx={{ w: 1 / 2 }}>{t('VerificationTypes.UserGroup')}</StyledHeaderCell>
            <StyledHeaderCell>{t('VerificationTypes.ViewReport')}</StyledHeaderCell>
            <StyledHeaderCell>{t('VerificationTypes.ViewSummary')}</StyledHeaderCell>
            <StyledHeaderCell align='right'>{t('VerificationTypes.Actions')}</StyledHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <>
            {verificationType.userGroups.length === 0 && (
              <StyledTableRow>
                <TableCell colSpan={4}>
                  <Box display='flex' gap={1} alignItems='center' justifyContent='center'>
                    <StyledGrayIcon fontSize='small'>error</StyledGrayIcon>
                    <Typography color='textSecondary'>{t('ResultsNotFound')}</Typography>
                  </Box>
                </TableCell>
              </StyledTableRow>
            )}
            {verificationType.userGroups.map((item, idx) => {
              return (
                <VerificationTypeUserGroupItemComponent
                  verificationTypeUserGroup={item}
                  index={idx}
                  key={idx}
                  onPropertyChanged={onPropertyChanged}
                  userGroups={userGroups}
                  allUserGroups={allUserGroups}
                  onDelete={onDelete}
                  onCancel={onCancel}
                  onEdit={onEdit}
                />
              );
            })}
          </>
        </TableBody>
      </StyledTable>
    </>
  );
};

VerificationTypeUserGroupsListComponent.propTypes = {
  verificationType: PropTypes.object.isRequired,
  userGroups: PropTypes.array.isRequired,
  allUserGroups: PropTypes.array.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired
};

export default VerificationTypeUserGroupsListComponent;
